import { GlobalState } from '../../actions';

const tournamentArchiveSelector = (state: GlobalState) => state.archive;

export const tournamentArchiveTournamentsSelector = (state: GlobalState) =>
    tournamentArchiveSelector(state).tournaments;

export const tournamentArchiveCategoriesSelector = (state: GlobalState) => tournamentArchiveSelector(state).categories;
